import React from "react";
import PropTypes from "prop-types";
import Warning from "../Warning/Warning";
import { renderIf } from "../../decorators";

export function CompanyAddressWarning({ company }) {
  return (
    <Warning>
      <a href={`/companies/${company && company.id}`}>
        {company && company.name}
      </a>
      &nbsp;does not have a primary shipping and/or billing address.
      &nbsp;Please update company information in order to proceed.
    </Warning>
  );
}

export default renderIf(
  ({ company }) =>
    company && (!company.primary_physical_address || !company.billing_address)
)(CompanyAddressWarning);

CompanyAddressWarning.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number
  })
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/CompanyAddressWarning/CompanyAddressWarning.jsx